import { useState, useEffect } from "react";
import { Modal, Stack, Form, Button, Spinner, Alert } from "react-bootstrap";
import editarUpload from "../functions/editarUpload";
import uploadDocumento from "../functions/uploadDocumento";
import { logBusinessAction } from "../services/AuditService";

function ModalUpload({
  isModalUpload,
  setIsModalUpload,
  actualizarEstadoProductos,
  productoEditar,
  setProductoEditar,
  usuario,
}) {
  const [productoEstado, setProductoEstado] = useState({ ...productoEditar });
  const [isDisabledButton, setIsDisabledButton] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [fileLink, setFileLink] = useState(null);

  useEffect(() => {
    setProductoEstado({ ...productoEditar });
    setIsDisabledButton(true);
    setFileLink(null);
    setUploadError("");
    setUploading(false);
  }, [productoEditar, isModalUpload]);

  async function fileHandler(e) {
    setUploading(true);
    setUploadError("");
    const documentoLocal = e.target.files[0];
    if (!documentoLocal) {
      setUploading(false);
      setIsDisabledButton(true);
      return;
    }
    try {
      const fecha = productoEstado.fecha || "";
      const dni = productoEstado.dni || "";
      const ano = fecha.substring(0, 4);
      if (ano >= 2018 && dni) {
        let nuevoNombreArchivo =
          documentoLocal.name.slice(0, -4) + "(" + Math.random() + ").pdf";
        const link = await uploadDocumento(
          documentoLocal,
          `documentos/${ano}/${dni}/${nuevoNombreArchivo}`,
          nuevoNombreArchivo,
          usuario.email
        );
        if (link) {
          setFileLink(link);
          setIsDisabledButton(false);
        } else {
          setUploadError("No se pudo subir el archivo.");
          setIsDisabledButton(true);
        }
      } else {
        setUploadError("Primero complete todos los campos correctamente.");
        setIsDisabledButton(true);
      }
    } catch (err) {
      setUploadError("Error al subir el archivo.");
      setIsDisabledButton(true);
    } finally {
      setUploading(false);
    }
  }

function editarProductoModal() {
  // Validar campos requeridos antes de guardar
  const fechaDoc = productoEstado.fecha
    ? new Date(productoEstado.fecha)
    : null;
  const fechaDocStr = fechaDoc
    ? fechaDoc.toLocaleString("es-PE", {
        timeZone: "America/Lima",
        dateStyle: "long",
        timeStyle: "medium"
      })
    : "";
  const dni = String(productoEstado.dni || "");
  const periodo = productoEstado.fecha
    ? productoEstado.fecha.substring(5, 7)
    : "";
  const ano = productoEstado.fecha
    ? productoEstado.fecha.substring(0, 4)
    : "";
  const ruc = usuario.ruc;
  const tipo = document.getElementById("tipo").value;

  // Mensajes de depuración
  console.log("=== GUARDAR DOCUMENTO ===");
  console.log("DNI:", dni);
  console.log("AÑO:", ano);
  console.log("PERIODO:", periodo);
  console.log("RUC:", ruc);
  console.log("TIPO:", tipo);
  console.log("fileLink:", fileLink);
  console.log("productoEstado:", productoEstado);

  // Validaciones
  if (!dni || !ano || !periodo || !fileLink) {
    console.error("Faltan campos requeridos:", { dni, ano, periodo, fileLink });
    setUploadError("Completa todos los campos y sube el archivo antes de guardar.");
    return;
  }

  // Nombre del documento
  let nombre = "";
  let archivo = "";
  if (document.getElementById("archivo").files[0]) {
    let docum = document
      .getElementById("archivo")
      .files[0].name.toUpperCase();
    archivo = docum.substring(0, docum.length - 4);
  }
  let mes = "";
  switch (periodo) {
    case "01": mes = "ENERO"; break;
    case "02": mes = "FEBRERO"; break;
    case "03": mes = "MARZO"; break;
    case "04": mes = "ABRIL"; break;
    case "05": mes = "MAYO"; break;
    case "06": mes = "JUNIO"; break;
    case "07": mes = "JULIO"; break;
    case "08": mes = "AGOSTO"; break;
    case "09": mes = "SETIEMBRE"; break;
    case "10": mes = "OCTUBRE"; break;
    case "11": mes = "NOVIEMBRE"; break;
    case "12": mes = "DICIEMBRE"; break;
    default: mes = ""; break;
  }
  switch (tipo) {
    case "Boletas de pago":
      nombre = "BOLETA DE PAGO " + mes + " " + ano;
      break;
    case "CTS":
      nombre = "LIQUIDACIÓN CTS " + mes + " " + ano;
      break;
    case "Contratos":
      nombre = "CONTRATO " + mes + " " + ano;
      break;
    case "Renta":
      nombre = "RENTA 5TA CATEGORIA " + mes + " " + ano;
      break;
    case "Utilidades":
      nombre = "LIQUIDACIÓN DE UTILIDADES " + mes + " " + ano;
      break;
    case "Prestamos":
      nombre = "PRESTAMO " + mes + " " + ano;
      break;
    case "Adelantos":
      nombre = "ADELANTO " + mes + " " + ano;
      break;
    case "Memorandums":
    case "Vacaciones":
    case "Ceses":
    case "Otros":
      nombre = archivo;
      break;
    default:
      nombre = "";
      break;
  }

  // Generar un id único (puedes usar un uuid o dejar que Firestore lo genere)
  const id = Math.random().toString(36).substring(2, 22);

  const infoProducto = {
    activo: true,
    ano: ano,
    contador: 0,
    dni: dni,
    fechaDoc: fechaDocStr,
    fechaVista: "",
    id: id,
    link: fileLink,
    nombre: nombre,
    periodo: periodo,
    ruc: ruc,
    semana: "",
    tipo: tipo
  };

  console.log("infoProducto a guardar:", infoProducto);

editarUpload(infoProducto, usuario.email, "document");

  // AUDITORÍA
  try {
    logBusinessAction("SUBIDA_DOCUMENTO_INDIVIDUAL", "GestionDocumentos", {
      dniDestino: dni,
      tipoDocumento: tipo,
      periodo: periodo,
      ano: ano
    }, usuario);
  } catch (e) {
    console.warn("No se pudo registrar la auditoría de subida", e);
  }

  setProductoEditar(null);
  setIsModalUpload(false);
  if (typeof actualizarEstadoProductos === "function") {
    actualizarEstadoProductos();
  }
}

  return (
    <Modal
      show={isModalUpload}
      onHide={() => {
        setIsModalUpload(false);
        setProductoEditar(null);
      }}
    >
      <Modal.Header>
        <Modal.Title>Subir Documento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Stack>
            DNI
            <Form.Control
              id="dni"
              placeholder="DNI"
              type="number"
              className="mb-1"
              value={productoEstado?.dni || ""}
              disabled
            />
            <br />
            Usuario
            <Form.Control
              id="name"
              placeholder="Nombres"
              type="text"
              className="mb-1"
              value={
                (productoEstado?.name ? productoEstado.name : "") +
                (productoEstado?.apellidos
                  ? " " + productoEstado.apellidos
                  : "")
              }
              disabled
            />
            <br />
            Fecha de Documento
            <Form.Control
              id="fecha"
              placeholder="Fecha"
              type="date"
              className="mb-1"
              required
              value={productoEstado?.fecha || ""}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  fecha: e.target.value,
                })
              }
            />
            <br />
            Tipo de Documento
            <Form.Select
              aria-label="Default select example"
              id="tipo"
              required
              defaultValue={"Boletas de pago"}
            >
              <option value="Boletas de pago">BOLETAS DE PAGO</option>
              <option value="CTS">CTS</option>
              <option value="Contratos">CONTRATOS</option>
              <option value="Renta">RENTA DE 5TA</option>
              <option value="Memorandums">MEMORANDUMS</option>
              <option value="Utilidades">UTILIDADES</option>
              <option value="Vacaciones">VACACIONES</option>
              <option value="Ceses">CESES / LIQUIDACIONES</option>
              <option value="Prestamos">PRESTAMOS</option>
              <option value="Adelantos">ADELANTOS</option>
              <option value="Otros">OTROS</option>
            </Form.Select>
            <br />
            Ubicación de Documento
            <Form.Control
              id="archivo"
              placeholder="Archivo"
              type="file"
              className="mb-1"
              required
              onChange={fileHandler}
            />
            {uploading && (
              <div className="my-2">
                <Spinner animation="border" size="sm" /> Subiendo archivo...
              </div>
            )}
            {uploadError && (
              <Alert variant="danger" className="my-2">
                {uploadError}
              </Alert>
            )}
            {fileLink && (
              <>
                <Alert variant="success" className="my-2">
                  Archivo subido correctamente.
                </Alert>
                <Alert variant="info" className="my-2">
                  Para finalizar el proceso, debes guardar el registro haciendo
                  clic en el botón <strong>Finalizar</strong>.
                </Alert>
              </>
            )}
          </Stack>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setIsModalUpload(false);
            setProductoEditar(null);
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          disabled={isDisabledButton || uploading}
          onClick={editarProductoModal}
        >
          {uploading
            ? "Subiendo..."
            : isDisabledButton
            ? "Esperando archivo..."
            : fileLink
            ? "Finalizar"
            : "Guardar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalUpload;
